export enum DeviceScreenSize {
    xs = 576,
    s = 768,
    md = 992,
    l = 1200,
    xl = 1400,
    mobile = 768,
    tablet = 1024
}

export enum ClientBrowser {
    Chrome = 'Chrome',
    Edge = 'Microsoft Edge',
    Safari = 'Safari',
    Android = 'Android Browser',
    Firefox = 'Firefox',
    IE = 'Internet Explorer'
}

export enum ClientPlatform {
    Mobile = 'mobile',
    Tablet = 'tablet',
    Desktop = 'desktop',
    TV = 'tv'
}

export enum ClientOS {
    Windows = 'Windows',
    MacOS = 'macOS',
    iOS = 'iOS',
    Android = 'Android',
    Linux = 'LInux',
    ChromeOS = 'Chrome OS'
}

export enum ClientEngine {
    EdgeHTML = 'EdgeHTML',
    Blink = 'Blink',
    WebKit = 'WebKit',
    Gecko = 'Gecko',
    Presto = 'Presto',
    Trident = 'Trident'
}

export interface IClientPlatform {
    browserDetails: any;
    isValid: boolean;
}

export interface IBrowserDetails {
    browser: Browser;
    os: OS;
    platform: Platform;
    engine: Engine;
    maxTouchPoints: number;
}

export interface Browser {
    name: string;
    version: string;
}

export interface OS {
    name: string;
    version: string;
    versionName: string;
}

export interface Platform {
    type: string;
    vendor: string;
    model: string;
}

export interface Engine {
    name: string;
    version: string;
}